import type { IconSvgObject } from './types';

const ArrowUpOneZeroIcon: IconSvgObject = [
  ["path", { d: "M4 8L8 4L12 8M8 5V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 5L18 4V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 10H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20 18V16C20 14.8954 19.1046 14 18 14C16.8954 14 16 14.8954 16 16V18C16 19.1046 16.8954 20 18 20C19.1046 20 20 19.1046 20 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ArrowUpOneZeroIcon;
